import * as React from "react";
function CartProblemIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M13.257 17.053a3.497 3.497 0 015.668-2.741l-4.892 4.938a3.482 3.482 0 01-.776-2.197zm1.307 2.726a3.496 3.496 0 004.895-4.941l-4.895 4.941zm2.19-6.973a4.246 4.246 0 100 8.493 4.246 4.246 0 000-8.493zM9.375 17.373c-1.05 0-1.875.825-1.875 1.875s.825 1.875 1.875 1.875 1.875-.825 1.875-1.875-.825-1.875-1.875-1.875zm0 3c-.6 0-1.125-.525-1.125-1.125s.525-1.125 1.125-1.125 1.125.525 1.125 1.125-.525 1.125-1.125 1.125z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.925 7.023c-.075-.075-.15-.15-.3-.15H6.375L6 4.923c0-.15-.225-.3-.375-.3h-2.25c-.225 0-.375.15-.375.375s.15.375.375.375h1.95l1.8 9.15c.225 1.2 1.35 2.1 2.55 2.1H11.3c.225 0 .375-.15.375-.375s-.15-.375-.375-.375H9.75c-.6 0-1.2-.3-1.5-.825l1.5-.205v-.001l1.608-.22c.226-.03.356-.2.325-.427-.03-.226-.202-.356-.428-.325l-1.602.199v-.002l-1.778.231-1.35-6.75H20.1l-.883 3.584h.003l-.17.696c-.055.222.056.405.278.46.221.054.405-.058.46-.279l.288-1.177L21 7.248s0-.15-.075-.225z"
  }));
}
const ForwardRef = React.forwardRef(CartProblemIcon);
export default ForwardRef;